import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import {
  Box,
  IconButton,
  ListSubheader,
  List as MuiList,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useCallback, useEffect, useRef } from "react";
import Pagination from "components/ui/atoms/Pagination";

const ListShort = ({
  title,
  resource,
  state,
  setState,
  ListItemComponent,
  FilterForm,
  TabList,
  addResource,
  listItemComponentProps,
  primaryClick,
  resourceStatus,
  emptyMessage,
  pagination,
  error,
}) => {
  const ref = useRef(null);
  const theme = useTheme();

  useEffect(() => {
    ref.current.parentNode.scrollTop =
      ref.current.offsetTop - ref.current.parentNode.offsetTop;
  }, [state]);

  const setFilter = useCallback(
    (filter) => {
      setState({ ...state, filter: filter, offset: 0 });
    },
    [state],
  );

  const setOffset = useCallback(
    (offset) => {
      setState({ ...state, offset: offset });
    },
    [state],
  );

  return (
    <Paper elevation={1} sx={{ height: 300, overflow: "scroll" }}>
      <MuiList dense ref={ref} sx={{ p: 0 }}>
        <ListSubheader
          key={"title"}
          color="primary"
          sx={{
            borderBottom: `1px solid ${theme.palette_custom.grey}`,
            p: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            lineHeight: 0,
          }}
        >
          <Typography
            textAlign="start"
            variant="subtitle2"
            sx={{ mr: 1, p: 1 }}
          >
            {title}
          </Typography>
          {FilterForm && (
            <FilterForm values={state.filter} onSubmit={setFilter} autoSubmit />
          )}
          {TabList && TabList}
          {addResource && (
            <IconButton onClick={addResource} sx={{ p: 0.5 }}>
              <AddCircleOutlineSharpIcon sx={{ scale: "0.8" }} />
            </IconButton>
          )}
        </ListSubheader>
        {resourceStatus == "success" && (
          <>
            {resource.results.length > 0 ? (
              <>
                {resource.results?.map((object, index) => {
                  return (
                    <ListItemComponent
                      key={index}
                      object={object}
                      primaryClick={primaryClick}
                      {...listItemComponentProps}
                    />
                  );
                })}
              </>
            ) : (
              <Typography variant="body1" mt={2} textAlign={"center"}>
                {emptyMessage}
              </Typography>
            )}
          </>
        )}
        {resourceStatus == "loading" ||
          (resourceStatus == "pending" && (
            <Stack spacing={1} p={1} sx={{ height: 300 }}>
              <Skeleton variant="rectangular" height={40} />
              <Skeleton variant="rectangular" height={40} />
              <Skeleton variant="rectangular" height={40} />
            </Stack>
          ))}
        {resourceStatus == "error" && (
          <Typography variant="body1" mt={2} textAlign={"center"}>
            Error while fetching data. {error && error.message}
          </Typography>
        )}
      </MuiList>
      {pagination && resourceStatus == "success" && (
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            py: 1,
          }}
        >
          <Pagination
            offset={state.offset}
            setOffset={setOffset}
            count={resource.count}
          />
        </Box>
      )}
    </Paper>
  );
};

export default ListShort;
